<template>
  <div>
    <el-row :gutter="40">
      <el-col :md="5">
        <el-menu default-active="1">
          <el-menu-item @click="changeTab(1)" index="1">{{
            $t("Información del Contrato")
          }}</el-menu-item>
          <el-menu-item @click="changeTab(2)" index="2">{{
            $t("Flujos de Revisión")
          }}</el-menu-item>
          <el-menu-item @click="changeTab(3)" index="3">{{
            $t("Revisores")
          }}</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :md="19" v-if="tab === 1 && contract" class="bordeIzquierdo">
        <el-row :gutter="20">
          <el-col :md="24">
            <div class="title">
              <b>{{ $t("Nombre") }}</b>
            </div>
            <el-input
              size="small"
              placeholder="Ingrese nombre del contrato"
              v-model="contract.nombre"
            ></el-input>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("Estado de este Contrato") }}</b>
            </div>
            <div class="status">
              <span
                :class="[
                  'safety-tag',
                  isActiveContract(contract) ? 'green' : 'red',
                ]"
                >{{
                  isActiveContract(contract) ? $t("Vigente") : $t("Vencido")
                }}</span
              >
            </div>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("¿Es sub-contrato?") }}</b>
            </div>
            <el-switch
              @change="setSubcontrato()"
              v-model="contract.subcontrato"
            >
            </el-switch>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("Número contrato") }}</b>
            </div>
            <el-input
              size="small"
              placeholder="Ingrese número del contrato"
              v-model="contract.numero_contrato"
            ></el-input>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("Fecha inicio") }}</b>
            </div>
            <el-date-picker
              class="full-width"
              type="date"
              size="small"
              placeholder="Ingrese nombre del contrato"
              v-model="contract['fecha_inicio']"
            ></el-date-picker>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("Fecha fin") }}</b>
            </div>
            <el-date-picker
              class="full-width"
              type="date"
              size="small"
              placeholder="Ingrese nombre del contrato"
              v-model="contract['fecha_fin']"
            ></el-date-picker>
          </el-col>
          <el-col :md="contract.tipo_contrato !== 'Propio' ? 8 : 12">
            <br />
            <div class="title">
              <b>{{ $t("Tipo") }}</b>
            </div>
            <el-select
              class="full-width"
              disabled
              size="small"
              v-model="contract.tipo_contrato"
              placeholder="Seleccionar un tipo de contrato"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :md="contract.tipo_contrato !== 'Propio' ? 8 : 12">
            <br />
            <div class="title">
              <b>{{ $t("Area") }}</b>
            </div>
            <el-select
              filterable
              class="full-width"
              size="small"
              v-model="contract.area_id"
              placeholder="Seleccionar el área del contrato"
            >
              <el-option
                v-for="(item, index) in areasTree"
                :key="index"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :md="8" v-if="contract.tipo_contrato !== 'Propio'">
            <br />
            <div class="title">
              <b>{{ $t("Empresa") }}</b>
            </div>
            <el-select
              filterable
              class="full-width"
              size="small"
              v-model="contract.empresa_id"
              placeholder="Seleccionar la empresa del contrato"
            >
              <el-option
                v-for="(item, index) in empresas"
                :key="index"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :md="8"
            v-if="
              contract.tipo_contrato !== 'Propio' &&
              contract.subcontrato === true
            "
          >
            <br />
            <div class="title">
              <b>{{ $t("Empresa mandante") }}</b>
            </div>
            <el-select
              filterable
              class="full-width"
              size="small"
              v-model="contract.subcontrato_empresa_id"
              placeholder="Seleccionar la empresa mandante del contrato"
            >
              <el-option
                v-for="(item, index) in empresas"
                :key="index"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :md="12"
            v-for="(val, i) in alcances"
            :key="i"
            v-if="contract.tipo_contrato !== 'Propio'"
          >
            <br />
            <div class="title">
              <b>{{ val }}</b>
            </div>
            <el-input
              type="textarea"
              :rows="4"
              v-model="contract[i]"
            ></el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :md="19" v-if="tab === 2 && contract" class="bordeIzquierdo">
        <el-row>
          <el-col :md="24">
            <h4>Flujo Revisión Riesgos de Salud</h4>
            <el-select
              @change="setWorkflow('salud', contract.workflows.salud)"
              style="padding-top: 10px; width: 100%; padding-bottom: 10px"
              v-model="contract.workflows.salud"
              placeholder="Seleccione un workflow"
            >
              <el-option
                v-for="item in workflows"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <Workflow
              v-if="contract.workflows.salud"
              :workflow="workflowSalud"
            />
            <br />
          </el-col>
          <el-col :md="24">
            <h4>Flujo Revisión Riesgos de Seguridad</h4>
            <el-select
              @change="setWorkflow('seguridad', contract.workflows.seguridad)"
              style="padding-top: 10px; width: 100%; padding-bottom: 10px"
              v-model="contract.workflows.seguridad"
              placeholder="Seleccione un workflow"
            >
              <el-option
                v-for="item in workflows"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <Workflow
              v-if="contract.workflows.seguridad"
              :workflow="workflowSeguridad"
            />
            <br />
          </el-col>
          <el-col :md="24">
            <h4>Flujo Revisión Riesgos de Medioambiente</h4>
            <el-select
              @change="
                setWorkflow('medioambiente', contract.workflows.medioambiente)
              "
              style="padding-top: 10px; width: 100%; padding-bottom: 10px"
              v-model="contract.workflows.medioambiente"
              placeholder="Seleccione un workflow"
            >
              <el-option
                v-for="item in workflows"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <Workflow
              v-if="contract.workflows.medioambiente"
              :workflow="workflowMedioambiente"
            />
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :key="forceUpdate"
        :md="19"
        v-if="tab === 3 && contract"
        class="bordeIzquierdo"
      >
        <el-row :gutter="10">
          <el-col
            :md="8"
            v-for="(people, profile) in contract.revisores"
            :key="profile"
          >
            <div
              v-if="validProfile(people) && profile !== 'hse'"
              class="people"
            >
              <div class="title">
                <b>{{ bhpProfiles[profile] }}</b>
                <br />
                <br />
                <PeopleSelect
                  v-for="(person, index) in people"
                  :key="index"
                  :model.sync="contract.revisores[profile][index]"
                  :users="
                    perfiles.bhp.includes(profile)
                      ? bhpUsersWithRole(profile, person)
                      : companyUsersWithRole(profile, person)
                  "
                />
              </div>
            </div>
          </el-col>
        </el-row>
        <hr />
        <el-row>
          <el-col :md="24">
            <h4>
              <span v-if="area"
                >{{ $t("Perfiles relacionados al área") }} "{{
                  area.nombre
                }}"</span
              >
              <span v-if="fatherArea"
                >, {{ $t("perteneciente a área") }} "{{
                  fatherArea.nombre
                }}"</span
              >
            </h4>
          </el-col>
          <el-col :md="6">
            <div class="title">
              <b>{{ $t("Superintendente") }}</b>
            </div>
            <p>{{ areaSuperintendente }}</p>
          </el-col>
          <el-col :md="6">
            <div class="title">
              <b>{{ $t("Superintendente") }}</b>
            </div>
            <p>{{ areaSuperintendentDos }}</p>
          </el-col>
          <el-col :md="6">
            <div class="title">
              <b>{{ $t("Gerente") }}</b>
            </div>
            <p>{{ areaManager }}</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Workflow from "@/components/workflows/Workflow2.vue";
import moment from "moment-timezone";
import { mapGetters, mapActions } from "vuex";
import PeopleSelect from "@/components/contracts/PeopleSelect.vue";
import axios from "axios";

export default {
  props: ["contract"],
  components: {
    Workflow,
    PeopleSelect,
  },
  async created() {
    this.getContractArea(this.contract.area_id);
    if (this.area_contract && this.area_contract.area_padre_id) {
      this.getContractFatherArea(this.area_contract.area_padre_id);
    }
    this.workflowSalud = await this.getWorkflow(this.contract.workflows.salud);
    this.workflowSeguridad = await this.getWorkflow(
      this.contract.workflows.seguridad
    );
    this.workflowMedioambiente = await this.getWorkflow(
      this.contract.workflows.medioambiente
    );
    this.getWorkflows();
  },
  data() {
    return {
      workflows: [],
      loading: false,
      forceUpdate: 0,
      tab: 1,
      area_contract: null,
      fatherArea: null,
      workflowSalud: null,
      workflowSeguridad: null,
      workflowMedioambiente: null,
      options: [
        {
          value: "Contratista",
          label: "Contratista",
        },
        {
          value: "Propio",
          label: "Propio",
        },
      ],
      alcances: {
        alcance: "Alcance",
        alcance_trabajo: "Alcance trabajo",
      },
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente"),
        super: this.$t("Superintendente"),
        general_manager: this.$t("Gerente General"),
      },
      perfiles: {
        companies: [
          "contractor_hse",
          "contractor_coordinator",
          "administrator",
          "contract_owner",
        ],
        bhp: [
          "hse",
          "health",
          "safety",
          "environment",
          "owner",
          "risk",
          "coordinator",
          "manager",
          "super",
          "general_manager",
        ],
      },
    };
  },
  watch: {
    contract: {
      handler(after, before) {
        this.forceUpdate = this.forceUpdate + 1;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      areasTree: "areas",
      empresas: "empresas",
    }),
    setSubcontrato() {
      if (this.contract.subcontrato === false) {
        this.contract.subcontrato_empresa_id = "";
      }
    },
    area() {
      return this.areasTree.find((area) => area._id === this.contract.area_id);
    },
    areaSuperintendente() {
      if (!this.area) return "no se encontro area";
      if (!this.area.super || !this.area.super.nombre) return "---";
      return `${this.area.super.nombre} ${this.area.super.apellido}`;
    },
    areaSuperintendentDos() {
      if (!this.area.super_dos || !this.area.super_dos.nombre) return "---";
      return `${this.area.super_dos.nombre} ${this.area.super_dos.apellido}`;
    },
    areaManager() {
      if (!this.area) return "no se encontro area";
      if (!this.area.gerente || !this.area.gerente.nombre) return "---";
      return `${this.area.gerente.nombre} ${this.area.gerente.apellido}`;
    },
    areaSuperiorManager() {
      if (!this.area) return "no se encontro area";
      if (!this.fatherArea) return "---";
      if (!this.fatherArea.gerente || !this.fatherArea.gerente.nombre) {
        return "---";
      }
      return `${this.fatherArea.gerente.nombre} ${this.fatherArea.gerente.apellido}`;
    },
  },
  methods: {
    async setWorkflow(tipo, id) {
      switch (tipo) {
        case "salud":
          this.workflowSalud = await this.getWorkflow(id);
          break;

        case "seguridad":
          this.workflowSeguridad = await this.getWorkflow(id);
          break;

        case "medioambiente":
          this.workflowMedioambiente = await this.getWorkflow(id);
          break;

        default:
          break;
      }
    },
    async getWorkflows() {
      let response = await axios.get(`/data-science/workflows`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      this.workflows = response.data;
    },
    changeTab(tab) {
      this.tab = tab;
    },
    async getWorkflow(id) {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(`workflow/${id}`, config);
      return response.data;
    },
    async getContractArea(id) {
      this.area_contract = await this.getArea(id);
    },
    async getContractFatherArea(id) {
      this.fatherArea = await this.getArea(id);
    },
    async getArea(id) {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(`areas/${id}`, config);
      return response.data;
    },
    getUser(id) {
      return this.$store.getters.usersFaena.find((x) => x._id === id);
    },
    validProfile(profile) {
      for (let i = 0; i < profile.length; i++) {
        if (profile[i] === "") {
          return false;
        }
        return true;
      }
    },
    companyUsersWithRole(role, currentUserId) {
      const current = [];

      const specifics = [];
      const others = [];
      this.$store.getters.usersFaena.forEach((user) => {
        if (user._id === currentUserId) {
          current.push(user);
        }
        if (
          user.roles.empresas &&
          user.roles.empresas[this.contract.empresa_id]
        ) {
          if (user.roles.empresas[this.contract.empresa_id].includes(role)) {
            specifics.push(user);
          } else {
            others.push(user);
          }
        }
      });
      return [
        { label: "Asignación Actual", options: current },
        { label: "Específicos", options: specifics },
        { label: "Otros", options: others },
      ];
    },
    bhpUsersWithRole(role, currentUserId) {
      const current = [];

      const admins = [];
      const specifics = [];
      const others = [];
      this.$store.getters.usersFaena.forEach((user) => {
        if (user._id === currentUserId) {
          current.push(user);
        }
        if (user.roles.admin) {
          admins.push(user);
        } else if (
          user.roles.areas &&
          user.roles.areas[this.contract.area_id] &&
          user.roles.areas[this.contract.area_id].includes(role)
        ) {
          specifics.push(user);
        } else if (user.roles.areas) {
          Object.keys(user.roles.areas).forEach((a) => {
            if (user.roles.areas[a].includes(role)) {
              others.push(user);
            }
          });
        }
      });
      return [
        { label: "Asignación Actual", options: current },
        { label: "Específicos del área", options: specifics },
        { label: "Otras áreas", options: others },
        { label: "Administrador Plataforma", options: admins },
      ];
    },
    isActiveContract(contract) {
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
  },
};
</script>

<style scoped>
.bordeIzquierdo {
  border-left: 1px solid black;
}

.title {
  color: #f67b2f;
  padding-bottom: 10px;
}

.el-menu {
  border-right: none;
}

.status {
  padding-top: 8px;
  padding-bottom: 4px;
}

.people {
  min-height: 150px;
}
</style>
